import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme, { withSearchBar } = {}) => ({
  layout: {
    paddingTop: withSearchBar ? 0 : theme.spacing(3),
    minHeight: 'calc(100vh - 305px)',
  },
  footer: {
    position: 'sticky',
    left: 'unset',
    right: 'unset',
  },
}));
